define([
	"dojo/store/util/SimpleQueryEngine",
	"csi/_base/underscore"
], function(SimpleQueryEngine,_) {

	return function(query, options) {
		// Add supports for query to be object where each key maps to an array of possible values, such as those coming
		// from csi/view/_QueryMixin; if a value contains "*", then match against value rather than test for exact equality.
		var	q = {};

		_.each(query, function(value, key) {
			if (_.isArray(value)) {
				// make sure none of values is just "*" which means match "all" - query can contain values that are objects with a test function,
				// so protect against case where "v" is not a string
				if (_.every(value, function(v) { return v.replace && !!v.replace(/\*/,""); })) {
					// construct RegExp from array of values
					var	a = _.map(value, function(v) {
						if (v[0] != "*") {
							v = "^" + v;
						}
						
						if (v[v.length-1] != "*") {
							v += "$";
						}
						
						return v.replace(/\*/g, ".*");
					});
					
					if (value = a.join("|")) {
						q[key] = new RegExp(value);
					}
				}
			} else {
				q[key] = value;
			}
		});
		
		return SimpleQueryEngine(q, options);
	};
});
